/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'

import MainImage from '../../../_metronic/assets/media/logos/Logo-light.png'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* <div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-1'>
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          <img
            className='theme-light-show mx-auto mw-100 w-150px w-lg-300px mb-10 mb-lg-20'
            src={MainImage}
            alt=''
          />

          <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
            Fast, Efficient and Productive
          </h1>

          <div>
            <h1 className='text-gray-800 fs-2qx fw-bold text-center mb-7'>
              Fast, Efficient and Productive
            </h1>

            <div className='text-gray-600 fs-base text-center fw-semibold'>
              In this kind of post,
              <a href='#' className='opacity-75-hover text-primary me-1'>
                the blogger
              </a>
              introduces a person they’ve interviewed
              <br />
              and provides some background information about
              <a href='#' className='opacity-75-hover text-primary me-1'>
                the interviewee
              </a>
              and their
              <br />
              work following this is a transcript of the interview.
            </div>
          </div>
        </div>
      </div> */}

      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-2'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* <img
            className='theme-light-show mx-auto mw-100 w-150px w-lg-300px mb-10 mb-lg-20'
            //src={MainImage}
            src={toAbsoluteUrl('/media/logos/Logo-dark.png')}
            alt=''
          /> */}
          {/* begin::Wrapper */}
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        {/* <div className='d-flex flex-center flex-wrap px-5'>
          <div className='d-flex fw-semibold text-primary fs-base'>
            <a href='#' className='px-5' target='_blank'>
              Terms
            </a>

            <a href='#' className='px-5' target='_blank'>
              Plans
            </a>

            <a href='#' className='px-5' target='_blank'>
              Contact Us
            </a>
          </div>
        </div> */}
        {/* end::Footer */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {AuthLayout}
